import { MaterialUICore } from '@iclinic/design-system';

const { makeStyles } = MaterialUICore;

const useStyles = makeStyles(() => ({
  title: {
    transition: 'margin-bottom 0.3s',
  },
}));

export default useStyles;
